<template>
  <div class="wrapper" :class="{ 'sidebar-open': isMobileMenuOpen }">
    
    <navBarComponent @toggle-menu="handleToggleMenu" />

    <sideBarComponent />

    <div 
      v-if="isMobileMenuOpen" 
      class="sidebar-overlay" 
      @click="isMobileMenuOpen = false"
    ></div>

    <div class="content-wrapper">
      <router-view class="router-content" />
    </div>

  </div>
</template>

<script>
import NavBarComponent from './inc/NavBarComponent.vue'
import SideBarComponent from './inc/SideBarComponenet.vue' // Ojo con el typo en tu nombre de archivo original

export default {
  components: {
    NavBarComponent,
    SideBarComponent
  },
  data() {
    return {
      isMobileMenuOpen: false
    }
  },
  methods: {
    handleToggleMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }
  },
  watch: {
    // Cierra el menú automáticamente si cambias de ruta (opcional pero recomendado)
    $route() {
      this.isMobileMenuOpen = false;
    }
  }
}
</script>

<style>
/* Estilos Base Desktop (manteniendo los tuyos) */
.main-sidebar {
  width: 269px !important;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1038;
  height: 100vh;
  transition: transform 0.3s ease-in-out, margin 0.3s ease-in-out;
}

.content-wrapper {
  margin-left: 269px !important;
  transition: margin-left 0.3s ease-in-out;
  min-height: 100vh;
  background-color: #f4f6f9;
}

/* --- ESTILOS RESPONSIVE PARA MÓVIL --- */
@media (max-width: 768px) {
  
  /* Por defecto en móvil, el sidebar está oculto (movido a la izquierda) */
  .main-sidebar {
    transform: translate(-269px, 0);
  }

  /* El contenido ocupa todo el ancho */
  .content-wrapper {
    margin-left: 0 !important;
  }

  /* Cuando la clase .sidebar-open está activa (agregada por Vue) */
  .wrapper.sidebar-open .main-sidebar {
    transform: translate(0, 0);
    box-shadow: 5px 0 15px rgba(0,0,0,0.3); /* Sombra para resaltar sobre el contenido */
  }

  /* El overlay oscuro */
  .sidebar-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1037; /* Justo debajo del sidebar (1038) pero encima del contenido */
    display: block;
    animation: fadeIn 0.3s;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.router-content {
  padding: 20px;
}
</style>